import { connect } from 'react-redux';
import { selectors as purchaseOrdersSelectors } from 'ducks/pickSlips/pickSlipTransaction';
import { getFormValues, reset, isDirty, destroy } from 'redux-form';
import { Dispatch, bindActionCreators } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { IApplicationState } from 'ducks/reducers';
import OrderDetails from './OrderDetails';

const FORM_NAME = 'PurchaseOrdersOrderDetails';

const mapStateToProps = (state: IApplicationState) => {
    return {
        selectedPurchaseOrder: purchaseOrdersSelectors.selected(state),
        dirty: isDirty(FORM_NAME)(state),
        formValues: getFormValues(FORM_NAME)(state),
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        resetForm: () => reset(FORM_NAME),
        destroyForm: () => destroy(FORM_NAME),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);
